<template>

<div>
 <form class="form-inline ">   
<label  for="desk">
  
  
   <i style="color:blue;font-size:24px;" class="fas fa-cash-register mr-2" aria-hidden="true"></i>
  
</label> 
 
<select id="desk" :disabled="!isAdmin" @change="$emit('setDesk',deskId)" class="form-control form-control" v-model="deskId">

    <option v-for="(item,index) in cassa" :value="item.value" :key="index">
      
      {{item.text}}</option>  
</select>
 </form>  
</div>

</template>
<script>
import { mapGetters }  from 'vuex'; 
export default {
    
 data () {
    return {
      
      deskId : 1,
    
      cassa  : [{text : 'CASSA 1',value:1},{text: 'CASSA 2',value:2},{text: 'CASSA 3',value:3},{text: 'CASSA 4',value:4},
     {text: 'CASSA 5',value:5},
     {text: 'CASSA 6',value:6}]
    

    }
  },
  computed: {
 ...mapGetters(['isAdmin']), 
  },
mounted()
{
   let deskId = JSON.parse(localStorage.getItem("deskId"))
    
  
    if(deskId)
    {
      
      this.deskId = Number(deskId)
    }
    this.$emit('setDesk',this.deskId)
},  

created()
{
  
},
methods :
{
    
}

}

</script>
<style scoped>

</style>